import { Interface } from '@ethersproject/abi'
import { ChainId } from '@stichting-allianceblock-foundation/alliance-dex-sdk'
import V1_EXCHANGE_ABI from './v1_exchange.json'
import V1_FACTORY_ABI from './v1_factory.json'

const V1_FACTORY_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xc0a47dFe034B400B47bDaD5FecDa2621de6c4d95',
  [ChainId.MATIC_MUMBAI]: '0x1f37bd4D72D1e4593dC7680Aa6e429B341829eB3', // WRONG ADDRESS
  [ChainId.EWC_VOLTA]: '0x1f37bd4D72D1e4593dC7680Aa6e429B341829eB3' // WRONG ADDRESS
}

const V1_FACTORY_INTERFACE = new Interface(V1_FACTORY_ABI)
const V1_EXCHANGE_INTERFACE = new Interface(V1_EXCHANGE_ABI)

export { V1_FACTORY_ADDRESSES, V1_FACTORY_INTERFACE, V1_FACTORY_ABI, V1_EXCHANGE_INTERFACE, V1_EXCHANGE_ABI }
